<script>
export default {
  inject: ["gsap"],
  name: "TitleBannersInvest",
  methods:{
    scrollToForm(){
      if (window.innerWidth <= 700){
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#lead-form2").offset().top -10
        }, 0);
      }
      else{
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#lead-form").offset().top -30
        }, 0);
      }
    }
  },
  mounted() {
    var element = $(".new-places-invest")
    this.gsap.to('.new-places-invest', {
      duration: 2,
      delay:2,
      scrollTrigger: {
        trigger: element, // Элемент, который будет триггером
        start: "top center", // Когда триггер сработает (например, когда верх элемента достигнет центра экрана)
        toggleClass: "active", // Добавляем/убираем класс "active" при срабатывании триггера
        once:true
      }
    });
  }
}
</script>

<template>
  <div class="new-places-invest left">
    <span class="sms-cloud-block blue" style="--sms-color-block:#1B6BB2">
      <svg width="606" height="455" viewBox="0 0 606 455" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="path-1-inside-1_681_1206" fill="white">
          <path d="M545.416 -0.000183105C578.553 -0.000183105 605.416 26.8628 605.416 59.9998V395C605.416 428.137 578.554 455 545.416 455H3.63861C0.835599 455 -0.638602 451.263 1.10089 449.065C9.21523 438.812 14.4614 423.225 14.6576 405.712L14.6625 404.693V59.9998C14.6626 26.863 41.5257 5.65875e-05 74.6625 -0.000183105H545.416Z"/>
        </mask>
        <path d="M545.416 -0.000183105C578.553 -0.000183105 605.416 26.8628 605.416 59.9998V395C605.416 428.137 578.554 455 545.416 455H3.63861C0.835599 455 -0.638602 451.263 1.10089 449.065C9.21523 438.812 14.4614 423.225 14.6576 405.712L14.6625 404.693V59.9998C14.6626 26.863 41.5257 5.65875e-05 74.6625 -0.000183105H545.416Z" fill="white"/>
        <path class="border" d="M605.416 59.9998L613.416 59.9998L613.416 59.9998L605.416 59.9998ZM14.6576 405.712L22.6571 405.801L22.6574 405.776L22.6576 405.75L14.6576 405.712ZM14.6625 404.693L22.6624 404.732L22.6625 404.712V404.693H14.6625ZM14.6625 59.9998L6.66253 59.9998V59.9998H14.6625ZM74.6625 -0.000183105L74.6625 -8.00018L74.6625 -8.00018L74.6625 -0.000183105ZM1.10089 449.065L7.37403 454.029L1.10089 449.065ZM545.416 -0.000183105V7.99982C574.135 7.99982 597.416 31.2811 597.416 59.9998L605.416 59.9998L613.416 59.9998C613.416 22.4446 582.972 -8.00018 545.416 -8.00018V-0.000183105ZM605.416 59.9998H597.416V395H605.416H613.416V59.9998H605.416ZM605.416 395H597.416C597.416 423.719 574.135 447 545.416 447V455V463C582.972 463 613.416 432.555 613.416 395H605.416ZM545.416 455V447H3.63861V455V463H545.416V455ZM1.10089 449.065L7.37403 454.029C16.798 442.121 22.4452 424.715 22.6571 405.801L14.6576 405.712L6.65815 405.622C6.47761 421.736 1.63245 435.502 -5.17224 444.1L1.10089 449.065ZM14.6576 405.712L22.6576 405.75L22.6624 404.732L14.6625 404.693L6.66262 404.655L6.65774 405.673L14.6576 405.712ZM14.6625 404.693H22.6625V59.9998H14.6625H6.66253V404.693H14.6625ZM14.6625 59.9998L22.6625 59.9998C22.6626 31.2813 45.944 8.00002 74.6626 7.99982L74.6625 -0.000183105L74.6625 -8.00018C37.1075 -7.99991 6.66264 22.4446 6.66253 59.9998L14.6625 59.9998ZM74.6625 -0.000183105V7.99982H545.416V-0.000183105V-8.00018H74.6625V-0.000183105ZM3.63861 455V447C6.22941 447 7.63692 448.781 8.05588 449.791C8.45266 450.748 8.6269 452.446 7.37403 454.029L1.10089 449.065L-5.17224 444.1C-8.16461 447.881 -8.12301 452.547 -6.72325 455.921C-5.30132 459.35 -1.7552 463 3.63861 463V455Z"  mask="url(#path-1-inside-1_681_1206)"/>
      </svg>
      <span class="sms-cloud-block-content">
        <span class="sms-cloud-block-content-txt">
          Наша компания обеспечит высокий <br>доход и безопасность Ваших<br> инвестиций.<br>
          Защитим права собственников и <br>арендаторов, а также обеспечит <br> комплексную подготовку и управление<br> арендными объектами.
        </span>
        <a href="tel:+74997151060" class="btn-num flex phone flex-xy-center">
          +7 (499) 715 - 10 - 60
        </a>
         <span class="btn-num black flex flex-xy-center" @click.prevent="scrollToForm()">
           Заказать звонок
         </span>
      </span>
    </span>
    <span class="sms-cloud-block-mob-default" style="--sms-color-block:#ff9166">
      <span class="sms-cloud-block-content">
        <span class="sms-cloud-block-content-txt">
          Наша компания поможет<br> подобрать и купить ликвидную<br> недвижимость в Москве.<br><br>
          Подготовим недвижимость к<br> сдаче, чтобы вы получали<br> максимальный доход от<br> аренды.
        </span>
         <span class="btn-num flex flex-xy-center" @click.prevent="scrollToForm()">
           Заказать звонок
         </span>
      </span>
    </span>
    <span class="accent-title left">Инвестиция <br>в ликвидные объекты</span>
    <svg class="blue-line-title mobile" width="223" height="22" viewBox="0 0 223 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 11C0 4.92487 4.92487 0 11 0H238V22H11C4.92487 22 0 17.0751 0 11Z" fill="#A6CFF2"/>
    </svg>
    <div class="orange-line-invest mobile-nv">

    </div>

    <div class="npi-container-img first left mobile-nv">

      <img src="/assets/invest11.png" alt="invest-title-1">
<!--      <router-link :to="{path : '/ourprojects', hash: '#tushino'}" class="geo-info left flex flex-xy-center">-->

<!--        <div class="circle-white flex flex-xy-center">-->
<!--          <svg width="61" height="62" viewBox="0 0 61 62" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--            <path fill-rule="evenodd" clip-rule="evenodd" d="M42.2753 15.7943C49.9082 22.1867 49.9082 34.2057 42.2753 40.5981L32.4798 51.3723C31.6863 52.2451 30.3137 52.2451 29.5202 51.3723L19.7247 40.5981C12.0918 34.2057 12.0918 22.1867 19.7247 15.7943C27.3577 9.40191 34.6423 9.4019 42.2753 15.7943ZM31 35C34.866 35 38 31.866 38 28C38 24.134 34.866 21 31 21C27.134 21 24 24.134 24 28C24 31.866 27.134 35 31 35Z" fill="#FF9166"/>-->
<!--          </svg>-->
<!--        </div>-->
<!--        <span>ЖК “Движение Тушино”</span>-->
<!--      </router-link>-->
    </div>
    <div class="npi-container-img right second mobile flex flex-x-center">
      <img src="/assets/invest12.png" alt="invest-title-1">

<!--      <div class="packet-mob left flex flex-xy-center mobile">-->
<!--        Инвестиция-->
<!--      </div>-->
    </div>
    <div class="npi-container-img-2 third left mobile-nv">
      <img src="/assets/invest12.png" alt="invest-title-2">
<!--      <router-link :to="{path : '/ourprojects', hash: '#tushino'}" class="geo-info left flex flex-xy-center">-->

<!--        <div class="circle-white flex flex-xy-center">-->
<!--          <svg width="61" height="62" viewBox="0 0 61 62" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--            <path fill-rule="evenodd" clip-rule="evenodd" d="M42.2753 15.7943C49.9082 22.1867 49.9082 34.2057 42.2753 40.5981L32.4798 51.3723C31.6863 52.2451 30.3137 52.2451 29.5202 51.3723L19.7247 40.5981C12.0918 34.2057 12.0918 22.1867 19.7247 15.7943C27.3577 9.40191 34.6423 9.4019 42.2753 15.7943ZM31 35C34.866 35 38 31.866 38 28C38 24.134 34.866 21 31 21C27.134 21 24 24.134 24 28C24 31.866 27.134 35 31 35Z" fill="#FF9166"/>-->
<!--          </svg>-->
<!--        </div>-->
<!--        <span>ЖК “Движение Тушино”</span>-->
<!--      </router-link>-->
    </div>

    <div class="rectangle-blue left"></div>
    <svg class="black-path mobile-nv" width="805" height="391" viewBox="0 0 805 391" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M265.343 354.334C260.719 361.776 181.756 377.448 179.584 378.983M179.584 378.983C177.728 380.297 217.445 311.763 200.07 290.064M179.584 378.983C295.004 314.845 339.977 251.838 237.923 199.434C135.869 147.03 -29.105 180.504 21.666 101.861C72.4371 23.2177 874.384 -110.242 825.5 260.114" stroke="#323232" stroke-width="24" stroke-miterlimit="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <svg class="black-path-mob mobile" width="355" height="212" viewBox="0 0 355 212" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M160.5 197C166.5 199 180 201 198.5 208M198.5 208C191 194.5 186.5 187.5 185 177M198.5 208C165 174 104.5 162.907 136.5 150.5C168.5 138.093 375.5 109 348.5 53.5C321.5 -1.99995 35 -25.0001 -22 59.5" stroke="#323232" stroke-width="7" stroke-miterlimit="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <div class="black-bg-under-text left mobile flex flex-xy-center">
      <span>Включает следующие этапы</span>
    </div>


  </div>
</template>

<style scoped>

</style>